import { useQuery } from "@tanstack/react-query";
import { AttendanceLocal } from "../../../@types/attendance-local";
import { apisiseci } from "../../api";
import { AxiosError } from "axios";

export function useAttendanceLocalDetails(slug: string) {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<AttendanceLocal, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['attendance-local', 'details', slug],
        queryFn: async () => {
            const response = await apisiseci.get<AttendanceLocal>(
                `/cms/unidades/${slug}/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            return response.data;
        },
    });
}
